import { render, staticRenderFns } from "./MemberGallery.vue?vue&type=template&id=1a6767be&scoped=true"
import script from "./MemberGallery.vue?vue&type=script&lang=ts"
export * from "./MemberGallery.vue?vue&type=script&lang=ts"
import style0 from "./MemberGallery.vue?vue&type=style&index=0&id=1a6767be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6767be",
  null
  
)

export default component.exports